const validateEnv = (env, name) => {
  if (!env || typeof env !== "string") {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return env;
};

const config = {
  API_BASE_URL: validateEnv(process.env.REACT_APP_API_BASE_URL, "REACT_APP_API_BASE_URL"),
  ORIGIN: validateEnv(process.env.REACT_APP_ORIGIN, "REACT_APP_ORIGIN"),
};

export default config;
